module.exports = __webpack_public_path__ + "media/site/images/case_studies/ekanban/solution3_2@2x-673dbbeaa8ec3f7152f9153b47945f77.png";